import flattenDeep from 'lodash/flattenDeep'
import adminItems from '@/navigation/vertical/admin'
import superAdminItems from '@/navigation/vertical/super-admin'
import store from '@/store'

const items = [...adminItems, ...superAdminItems]
console.log("items", items)
function getChildren(item) {
  if (!item.children) {
    return [item]
  }
  return [item].concat(item.children.map(child => ({ ...child, icon: child.icon || item.icon })).map(child => getChildren(child)))
}

export function pages() {
  const isSuperAdminRoute = store.getters['navigation/isSuperAdminRoute']
  return flattenDeep((isSuperAdminRoute ? superAdminItems : adminItems).map(item => getChildren(item))).filter(value => !!value)
}

export default items
